import dotenv from 'dotenv';

import { coerce } from '../lib/helpers';

dotenv.config({ path: '.env.local', debug: coerce(process.env.DEBUG) });
// files below will not override and environement variables set above
dotenv.config({ path: '.env.global.production' });
dotenv.config({ path: `.env.${process.env.MARKET}.production` });
